<template>
    <div class="container-fluid">
        <!-- control the device display globally -->
        <div class="row">
            <div class="offset-lg-2 col-lg-8 col-12">
                
                <!-- show loaded cart -->
                <template v-if="theItemsInCart">
                    <div class="row mt-3">
                        <div class="col-12">
                            <div class="float-sm-left">
                                <h4 class="m-0 pt-1"><i class="fas fa-shopping-cart"></i> <span class="text-dark-green">My Shopping Cart</span></h4>
                            </div>
                            <div class="float-sm-right d-none d-sm-block">
                                <router-link :to="{ name: 'checkout-information' }" class="btn btn-dark-green form-control">
                                    Proceed to Checkout
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="row">
                                <app-cart-item 
                                    v-for="(item, index) in theItemsInCart" 
                                    :key="index" :item="item" 
                                    :pageName="'CartItem'" 
                                    @emitUpdateItemQtyFxn="updateItemQtyFxn" 
                                ></app-cart-item>
                            </div>
                        </div>
                    </div>
                    <div class="row my-3">
                        <div class="col-12">
                            <div class="float-sm-right">
                                <router-link :to="{ name: 'checkout-information' }" class="btn btn-dark-green form-control">
                                    Proceed to Checkout
                                </router-link>
                            </div>
                            <div class="float-sm-left">
                                <p class="text-center m-0 pt-2">
                                    <router-link :to="{ name: 'home' }">
                                        <i class="fas fa-chevron-left fa-xs"></i> Return to Shopping
                                    </router-link>
                                </p>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                </template>
                
                <!-- show cart empty message -->
                <template v-else>
                    <div class="row">
                        <div class="col-12 mt-3 text-center">
                            <div class="clearfix">
                                <p class="text-danger fa-lg float-sm-left py-2 mb-sm-0">
                                    <i class="fas fa-shopping-cart d-none d-sm-inline"></i>
                                    Your shopping cart is empty!
                                </p>
                                <router-link :to="{ name: 'home' }" class="btn btn-dark-green float-sm-right">
                                    Continue Shopping
                                </router-link>
                            </div>
                        </div>
                    </div>
                </template>

                <!-- explore categories -->
                <div class="my-5">
                    <app-more-categories :displayedCategory="'none'"></app-more-categories>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import CartItem from './shoppingCartParts/CartItem.vue';
import LayoutGeneral from '@/layouts/General.vue'
import MoreCategories from './itemDetailsParts/MoreCategories.vue';

export default {
    name: "ShoppingCart",
    methods: {
        ...mapActions(['fetchCartItemsAction']),
        fetchCartItemsFxn() {
            let cartObj = {
                items: []
            }
            
            // obtain the cart-items from local-storage and updated cart obj
            let localStorageATCItemIds = JSON.parse(localStorage.getItem('ani_items_atc')) 
            if(localStorageATCItemIds && localStorageATCItemIds.length) {
                cartObj.items = localStorageATCItemIds
            } 
            this.fetchCartItemsAction(cartObj).then(() => {}).catch((e) => {})
        },
        updateItemQtyFxn(theUpdateObj) {
            // ensure there is an item obj to update
            if(!theUpdateObj) return
            
            // required array to hold cart items
            let localStorageATCItemIds = []

            // check if user already have a add-to-cart items storage on local-storage
            localStorageATCItemIds = JSON.parse(localStorage.getItem('ani_items_atc')) 
            if(localStorageATCItemIds && localStorageATCItemIds.length) {
                // update item quantity and sum-price if the item already exists in shoppers cart
                let existingCartItemIndex = localStorageATCItemIds.findIndex(cartItem => cartItem.itemId === theUpdateObj.itemId)
                if(existingCartItemIndex !== -1){
                    let existingCartItemObj = localStorageATCItemIds[existingCartItemIndex]
                    existingCartItemObj.itemQty = theUpdateObj.itemQty
                    existingCartItemObj.itemPrice = theUpdateObj.itemPrice
                    existingCartItemObj.itemSumPrice = theUpdateObj.itemSumPrice // already multiplied in CartItem.vue - theUpdateObjFxn
                    localStorageATCItemIds.splice(existingCartItemIndex, 1, existingCartItemObj)
                } 
                localStorage.setItem('ani_items_atc', JSON.stringify(localStorageATCItemIds))
            } 
        }
    },
    computed: {
        ...mapGetters(['itemsInCart']),
        theItemsInCart() {
            if(this.itemsInCart){
                return this.itemsInCart
            }
            return false
        },
    },
    components: {
        appCartItem: CartItem,
        appMoreCategories: MoreCategories
    },
    created() {
        this.fetchCartItemsFxn()
        this.$emit('update:layout', LayoutGeneral);
    }
}
</script>